import { RootState } from '../root.reducers';
import { SipSetting, SipSettingErrors } from './sipSetting.types';

export const getSipSettingList = (state: RootState): SipSetting[] =>
  state.sipSetting.entities;

export const getSipSetting = (state: RootState): SipSetting | null =>
  state.sipSetting.single;

export const getSelectedSipSetting = (state: RootState): SipSetting[] =>
  state.sipSetting.selected;

export const getSipSettingCreatedId = (state: RootState): string | null =>
  state.sipSetting.createdId;

export const isSipSettingCreatePopupOpen = (state: RootState): boolean =>
  state.sipSetting.ui.isCreatePopupOpen;

export const isSipSettingLoading = (state: RootState): boolean =>
  state.sipSetting.ui.isLoading;

export const getSipSettingErrors = (state: RootState): SipSettingErrors =>
state.sipSetting.sipSettingErrors;
